import {
  GET_SETTINGS_SITES,
} from './actions';

export default function(state = {}, action) {
  switch (action.type) {
    case GET_SETTINGS_SITES:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sites/index.js